import { useEffect, useState } from "react";
import DocumentHolderSm from "./DocumentHolderSm";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";

const DocumentBoxV2 = (props) => {
  const { documentDetails } = props;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, [documentDetails]);

  const displayBlockContent = () => {
    if (isLoading) {
      return <LoadingPageSm />;
    } else {
      return renderDocuments();
    }
  };

  const renderDocuments = () => {
    if (documentDetails !== null && documentDetails) {
      return (
        <div>
          {documentDetails.map((item) => {
            return (
              <div key={item.document_id.toString()}>
                <DocumentHolderSm
                  title={item.document_title}
                  path={item.document_path}
                />
              </div>
            );
          })}
        </div>
      );
    } else {
      return <span className="text-muted">Nothing to display here!</span>;
    }
  };
  return (
    <>
      <div className="fw-medium mb-2">Files / Document</div>
      {displayBlockContent()}
    </>
  );
};

export default DocumentBoxV2;
